var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthcondition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_192_health_flatline",
    "data-name": "#192_health_flatline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.3,64.38H82.7c-7.87,0-14.24,6.71-14.24,15v124.4c0,8.28,6.37,15,14.24,15H317.3c7.87,0,14.24-6.71,14.24-15V79.37C331.54,71.09,325.17,64.38,317.3,64.38Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.3,219.26H82.7c-8.13,0-14.74-6.95-14.74-15.49V79.37c0-8.54,6.61-15.49,14.74-15.49H317.3c8.13,0,14.74,6.95,14.74,15.49v124.4C332,212.31,325.43,219.26,317.3,219.26ZM82.7,64.88C75.12,64.88,69,71.38,69,79.37v124.4c0,8,6.16,14.49,13.74,14.49H317.3c7.58,0,13.74-6.5,13.74-14.49V79.37c0-8-6.16-14.49-13.74-14.49Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.12,163.2h53.71a0,0,0,0,1,0,0v66a5.34,5.34,0,0,1-5.34,5.34h-43a5.34,5.34,0,0,1-5.34-5.34v-66A0,0,0,0,1,258.12,163.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.83,163.2v66a5.35,5.35,0,0,1-5.34,5.35h-43a5.35,5.35,0,0,1-5.34-5.35v-66h53.71m0-1H258.12a1,1,0,0,0-1,1v66a6.35,6.35,0,0,0,6.34,6.35h43a6.35,6.35,0,0,0,6.34-6.35v-66a1,1,0,0,0-1-1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.12,
    y: 181.13,
    width: 53.71,
    height: 26.28,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.31,
    y: 141.3,
    width: 63.32,
    height: 21.9,
    rx: 2.65,
    fill: "#678aeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,141.3a2.65,2.65,0,0,1,2.65,2.65v16.6A2.65,2.65,0,0,1,314,163.2H256a2.65,2.65,0,0,1-2.65-2.65V144A2.65,2.65,0,0,1,256,141.3h58m0-1H256a3.66,3.66,0,0,0-3.65,3.65v16.6A3.66,3.66,0,0,0,256,164.2h58a3.66,3.66,0,0,0,3.65-3.65V144A3.66,3.66,0,0,0,314,140.3Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.75,162.6a.5.5,0,0,1-.5-.5V142.39a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5V162.1A.5.5,0,0,1,258.75,162.6Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.3,162.6a.5.5,0,0,1-.5-.5V142.39a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5V162.1A.5.5,0,0,1,265.3,162.6Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.86,162.6a.5.5,0,0,1-.5-.5V142.39a.5.5,0,0,1,1,0V162.1A.5.5,0,0,1,271.86,162.6Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.42,162.6a.5.5,0,0,1-.5-.5V142.39a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5V162.1A.5.5,0,0,1,278.42,162.6Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,162.6a.5.5,0,0,1-.5-.5V142.39a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5V162.1A.5.5,0,0,1,285,162.6Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.53,162.6a.5.5,0,0,1-.5-.5V142.39a.5.5,0,0,1,1,0V162.1A.5.5,0,0,1,291.53,162.6Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.09,162.6a.5.5,0,0,1-.5-.5V142.39a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5V162.1A.5.5,0,0,1,298.09,162.6Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,162.6a.5.5,0,0,1-.5-.5V142.39a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5V162.1A.5.5,0,0,1,304.64,162.6Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.2,162.6a.5.5,0,0,1-.5-.5V142.39a.5.5,0,0,1,1,0V162.1A.5.5,0,0,1,311.2,162.6Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.76 80.07 247.76 228.67 104.04 228.67 104.04 53.79 219.83 53.79 247.76 80.07",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.83,53.79l27.93,26.28v148.6H104V53.79H219.83m0-1H104a1,1,0,0,0-1,1V228.67a1,1,0,0,0,1,1H247.76a1,1,0,0,0,1-1V80.07a1,1,0,0,0-.31-.73L220.51,53.06a1,1,0,0,0-.68-.27Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.66,75h-8V67a2.14,2.14,0,0,0-2.14-2.15h-5.16A2.15,2.15,0,0,0,171.18,67v8h-8A2.15,2.15,0,0,0,161,77.19v5.16a2.14,2.14,0,0,0,2.15,2.14h8v8a2.14,2.14,0,0,0,2.15,2.14h5.16a2.14,2.14,0,0,0,2.14-2.14v-8h8a2.14,2.14,0,0,0,2.14-2.14V77.19A2.14,2.14,0,0,0,188.66,75Z",
    fill: "#678aeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.81,109.1H123.64a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h64.17a.51.51,0,0,1,.5.5A.5.5,0,0,1,187.81,109.1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.18,109.1H206.4a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h21.78a.51.51,0,0,1,.5.5A.5.5,0,0,1,228.18,109.1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.25,123H123.64a.5.5,0,0,1,0-1h49.61a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.76,123H206.4a.5.5,0,0,1,0-1h19.36a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.48,136.84H123.64a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h56.84a.5.5,0,0,1,.5.5A.5.5,0,0,1,180.48,136.84Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.18,136.84H206.4a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h21.78a.5.5,0,0,1,.5.5A.51.51,0,0,1,228.18,136.84Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.25,150.71H123.64a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h49.61a.5.5,0,0,1,.5.5A.5.5,0,0,1,173.25,150.71Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.55,150.71H206.4a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h18.15a.5.5,0,0,1,.5.5A.5.5,0,0,1,224.55,150.71Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.81,164.57H123.64a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h64.17a.51.51,0,0,1,.5.5A.5.5,0,0,1,187.81,164.57Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.18,164.57H206.4a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h21.78a.51.51,0,0,1,.5.5A.5.5,0,0,1,228.18,164.57Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.16,178.44H123.64a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h42.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,166.16,178.44Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.18,178.44H206.4a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h21.78a.51.51,0,0,1,.5.5A.5.5,0,0,1,228.18,178.44Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.76,193.51H122.05a.5.5,0,0,1,0-1H229.76a.5.5,0,0,1,0,1Z",
    fill: "#678aeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.76,207.5H208a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h21.77a.5.5,0,0,1,.5.5A.5.5,0,0,1,229.76,207.5Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "219.83 53.79 219.83 79.77 247.76 79.77",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.23,224.63a7.07,7.07,0,0,1-7.07,7.06H206.43a7.07,7.07,0,0,1,0-14.13h34.73A7.08,7.08,0,0,1,248.23,224.63Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.16,217.56a7.07,7.07,0,1,1,0,14.13H206.43a7.07,7.07,0,0,1,0-14.13h34.73m0-1H206.43a8.07,8.07,0,0,0,0,16.13h34.73a8.07,8.07,0,1,0,0-16.13Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.8,217.56s-2.2,1.21-2.2,7.07c0,5.42,2.2,7.06,2.2,7.06H206.43a7.07,7.07,0,0,1,0-14.13Z",
    fill: "#678aeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.88,236.14a7.07,7.07,0,0,0,7.24,6.89l34.72-.84a7.07,7.07,0,1,0-.34-14.13l-34.72.84A7.08,7.08,0,0,0,214.88,236.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.67,228.06a7.07,7.07,0,0,1,.17,14.13l-34.72.84H222a7.07,7.07,0,0,1-.17-14.14l34.72-.84h.17m0-1h-.19l-34.73.84A8.07,8.07,0,0,0,222,244h.2l34.72-.84a8.07,8.07,0,0,0-.2-16.13Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.14,228.48a12.65,12.65,0,0,1,2.31,6.86,16.73,16.73,0,0,1-2,7.27l17.36-.42a7.07,7.07,0,1,0-.34-14.13Z",
    fill: "#678aeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.3,229.54v6c0,3.32-7.23,6-16.16,6s-16.15-2.7-16.15-6v-6Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.3,229.54v6c0,3.32-7.23,6-16.16,6s-16.15-2.7-16.15-6v-6H178.3m0-1H146a1,1,0,0,0-1,1v6c0,4.56,8.84,7,17.15,7s17.16-2.46,17.16-7v-6a1,1,0,0,0-1-1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.14,
    cy: 229.54,
    rx: 16.16,
    ry: 6.02,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.14,223.53c8.93,0,16.16,2.69,16.16,6s-7.23,6-16.16,6-16.15-2.69-16.15-6,7.23-6,16.15-6m0-1c-8.31,0-17.15,2.46-17.15,7s8.84,7,17.15,7,17.16-2.46,17.16-7-8.84-7-17.16-7Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.19,236.93a.5.5,0,0,1-.34-.13l-14.24-12.9a.5.5,0,0,1,.68-.74l14.23,12.9a.5.5,0,0,1,0,.71A.49.49,0,0,1,170.19,236.93Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.58,234.18v6c0,3.33,7.24,6,16.16,6s16.16-2.69,16.16-6v-6Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.9,234.18v6c0,3.33-7.24,6-16.16,6s-16.16-2.69-16.16-6v-6H144.9m0-1H112.58a1,1,0,0,0-1,1v6c0,4.56,8.84,7,17.16,7s17.16-2.46,17.16-7v-6a1,1,0,0,0-1-1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.74,
    cy: 234.18,
    rx: 16.16,
    ry: 6.02,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.74,228.16c8.92,0,16.16,2.69,16.16,6s-7.24,6-16.16,6-16.16-2.69-16.16-6,7.24-6,16.16-6m0-1c-8.32,0-17.16,2.46-17.16,7s8.84,7,17.16,7,17.16-2.46,17.16-7-8.84-7-17.16-7Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.83,240.25a.51.51,0,0,1-.36-.15L123.2,228.51a.5.5,0,1,1,.72-.7l11.27,11.59a.5.5,0,0,1,0,.71A.49.49,0,0,1,134.83,240.25Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.83,219.35v6c0,3.32,7.23,6,16.16,6s16.15-2.7,16.15-6v-6Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.14,219.35v6c0,3.32-7.23,6-16.15,6s-16.16-2.7-16.16-6v-6h32.31m0-1H129.83a1,1,0,0,0-1,1v6c0,4.56,8.84,7,17.16,7s17.15-2.46,17.15-7v-6a1,1,0,0,0-1-1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.99,
    cy: 219.35,
    rx: 16.16,
    ry: 6.02,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,213.33c8.92,0,16.15,2.7,16.15,6s-7.23,6-16.15,6-16.16-2.7-16.16-6,7.23-6,16.16-6m0-1c-8.32,0-17.16,2.46-17.16,7s8.84,7,17.16,7,17.15-2.46,17.15-7-8.84-7-17.15-7Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.74,225.34a.5.5,0,0,1-.25-.93l19.4-11.17a.51.51,0,0,1,.69.18.5.5,0,0,1-.19.68L135,225.28A.57.57,0,0,1,134.74,225.34Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.55,117.35H262.9a.5.5,0,0,1-.5-.5V89a.5.5,0,0,1,.5-.5h45.65a.51.51,0,0,1,.5.5v27.81A.51.51,0,0,1,308.55,117.35Zm-45.15-1h44.65V89.54H263.4Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,98H271.86a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H300a.5.5,0,0,1,.5.5A.5.5,0,0,1,300,98Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.06,106.84h-21.2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h21.2a.5.5,0,0,1,.5.5A.5.5,0,0,1,293.06,106.84Z",
    fill: "#d1d3d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcondition);
export default __webpack_public_path__ + "static/media/healthcondition.57c2d1da925d5c65493c7d484f72f461.svg";
export { ForwardRef as ReactComponent };